import { FC, useContext } from 'react';
import styles from './SearchBarLocationInput.module.scss';
import { AppContext } from '../../../context/AppContext';
import { checkValidZip, evaluateIsDisabled } from '../../../lib/util';
import { defaultAppState } from '../../../context/DefaultAppState';

const SearchBarLocationInput: FC = () => {
  const { location, updateLocation, distance, updateIsDisabled, search, updateSearch } = useContext(AppContext);
  const onSearchBarLocationChange = (e: any) => {
    updateLocation(e.target.value);
    const result = checkValidZip(e.target.value);
    let updatedSearch = { ...search, isValidZIP: result };
    const tempDistance = distance.distance ? distance.distance : defaultAppState.distance.distance;
    if (tempDistance !== defaultAppState.distance.distance) {
      updatedSearch = { required: true, isValidZIP: result };
    } else {
      updatedSearch = { required: false, isValidZIP: result };
    }

    updateSearch(updatedSearch);
    let currentLocation = e.target.value ? e.target.value : null;
    const valueResult = evaluateIsDisabled(updatedSearch, currentLocation, distance.distance);

    updateIsDisabled(valueResult);
  };

  return (
    <>
      <div className={styles.locationInputContainer}>
        <input className={styles.locationInput} type="text" placeholder="ZIP code" value={location === 'undefined' ? '' : location} onChange={onSearchBarLocationChange} />
      </div>
    </>
  );
};

export default SearchBarLocationInput;
